/** Nazivi načina plaćanja; ključ je vrijednost enuma s poslužitelja. */
export const BILLING_PERIOD_LABELS: Record<string, string> = {
  Monthly: "Mjesečno plaćanje",
  Annual: "Godišnje plaćanje",
};
